import gql from 'graphql-tag';
import { PAGINATION_VIEW_MODEL_FRAGMENT } from 'shared';

import { DEAL_SHEET_CONFIGURATION_FRAGMENT } from './configurationFragment';

export const GET_DEAL_SHEET_TABLE_CONFIGURATIONS = gql`
  query DealSheetTableConfigurations($input: DealSheetTableConfigurationsInput!) {
    dealSheets {
      result: dealSheetTableConfigurations(input: $input) {
        success
        error
        pagination {
          ...PaginationMetaViewModel
        }
        items {
          ...DealSheetConfig
        }
      }
    }
  }
  ${DEAL_SHEET_CONFIGURATION_FRAGMENT}
  ${PAGINATION_VIEW_MODEL_FRAGMENT}
`;
